import isEmpty from 'lodash/isEmpty';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classNames from 'classnames';
import moment from 'moment';
import DayPicker, {DateUtils as DayPickerDateUtils} from 'react-day-picker';
import DateUtils from 'date-utils';
import SHGlobals from 'sh-globals';

const DATE = new Date();

class DatePickerCalendar extends Component {
    constructor(props) {
        super(props);

        const {
            selectedDate
        } = props;

        this._IS_NATIVE_DATE_INPUT = SHGlobals.isMobile && DateUtils.supportsDateInput();
        this._DATE_FORMAT = (this._IS_NATIVE_DATE_INPUT) ? SHGlobals.MOBILE_DATE_FORMAT : SHGlobals.DESKTOP_DATE_FORMAT;
        this._onDaySelected = this._onDaySelected.bind(this);
        this._modifierSelected = this._modifierSelected.bind(this);
        this._modifierDisabled = this._modifierDisabled.bind(this);

        this.state = {
            selectedDate: (this._IS_NATIVE_DATE_INPUT) ? DateUtils.convertToMobile(selectedDate) : selectedDate
        };
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    _onDaySelected(day, {selected, disabled}, evt) {
        const {
            onChange
        } = this.props;

        if (disabled) { return; }

        if (onChange) {
            onChange(moment(day).format(this._DATE_FORMAT));
        }
    }

    _modifierSelected(day) {
        const {
            selectedDate
        } = this.state;

        if (!isEmpty(selectedDate)) {
            return DayPickerDateUtils.isSameDay(DateUtils.getAsDate(selectedDate), day);
        } else {
            return null;
        }
    }

    _modifierDisabled(day) {
        const {
            disablePast,
            disableBefore,
            disableAfter
        } = this.props;
        let isDayDisabled = false;
        let disableDay = false;

        if (disableBefore) {
            disableDay = DateUtils.isBefore(day, DateUtils.getAsDate(disableBefore));
            isDayDisabled = disableDay;
        }

        if (disableAfter && !isDayDisabled) {
            disableDay = DateUtils.isAfter(day, DateUtils.getAsDate(disableAfter));
            isDayDisabled = disableDay;
        }

        if (disablePast && !isDayDisabled) {
            disableDay = DayPickerDateUtils.isPastDay(day);
        }

        return disableDay;
    }

    _renderDayMarkup(day) {
        const m = moment(day);
        const date = `${m.format('MM')}/${m.format('DD')}/${m.format('YYYY')}`;

        return <span data-date={date}>{day.getDate()}</span>;
    }

    render() {
        const {
            className,
            disablePast,
            disableBefore,
            disableAfter
        } = this.props;
        const {
            selectedDate
        } = this.state;
        const classes = classNames(
            'DatePicker-calendar',
            className
        );
        let initialMonth = DATE;
        let fromMonth = (disablePast)
            ? DATE
            : null;
        let toMonth = null;

        if (disableBefore) {
            const beforeDate = DateUtils.getAsDate(disableBefore);

            if (fromMonth) {
                if (DateUtils.isAfter(beforeDate, fromMonth)) {
                    fromMonth = beforeDate;
                }
            } else {
                fromMonth = beforeDate;
            }
        }

        if (disableAfter) {
            toMonth = DateUtils.getAsDate(disableAfter);
        }

        if (selectedDate) {
            initialMonth = DateUtils.getAsDate(selectedDate);
        }

        return (
            <div className={classes}>
                <DayPicker
                    selectedDays={this._modifierSelected}
                    disabledDays={this._modifierDisabled}
                    onDayClick={this._onDaySelected}
                    fromMonth={fromMonth}
                    toMonth={toMonth}
                    month={initialMonth}
                    renderDay={this._renderDayMarkup}
                    enableOutsideDays
                />
            </div>
        );
    }
}

DatePickerCalendar.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func,
    /** A string in the format 'MM/DD/YYYY' representing the date which should be selected on the calendar. */
    selectedDate: PropTypes.string,
    /** Whether to disable the days on the calendar that are in the past. */
    disablePast: PropTypes.bool,
    /** A string in the format 'MM/DD/YYYY' representing the date where any day prior is disabled. */
    disableBefore: PropTypes.string,
    /** A string in the format 'MM/DD/YYYY' representing the date where any day past is disabled. */
    disableAfter: PropTypes.string
};

DatePickerCalendar.defaultProps = {
    selectedDate: '',
    disablePast: true
};

export default DatePickerCalendar;



// WEBPACK FOOTER //
// ./frontend/src/js/components/date-picker/DatePickerCalendar.jsx